import { REQUEST_GET_SAVED_REPORTS, RESPONSE_GET_SAVED_REPORTS, REQUEST_GET_SAVED_REPORTS_FAILURE } from "../actions/savedReportsActions";

import { RESPONSE_DELETE_REPORT } from "../actions/deleteReportActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  list: [],
  total: 0,
};

const savedReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_SAVED_REPORTS: {
      return Object.assign({}, state, {
        dataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_GET_SAVED_REPORTS: {
      var nextState = Object.assign({}, state);

      nextState.dataState = queriesStates.READY;
      nextState.list = action.data.savedReports;
      nextState.total = action.data.total;

      return Object.assign({}, state, nextState);
    }
    case REQUEST_GET_SAVED_REPORTS_FAILURE: {
      return Object.assign({}, state, {
        dataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }
    case RESPONSE_DELETE_REPORT: {
      var nextState = Object.assign({}, state);

      nextState.list = state.list.filter((x) => {
        return x.id !== action.data;
      });
      nextState.total = state.total - 1;

      return Object.assign({}, state, nextState);
    }
    default:
      return state;
  }
};

export default savedReportsReducer;
